export default __webpack_public_path__ + "b8ab9e4ef92f1a880a2b8b2e25ad3701.png";